const rel = '';

export { rel };
export default rel;
